export default __webpack_public_path__ + "static/media/ic_bar_left_payment.bb72be2f.svg";